import React from 'react'
import Container from 'components/Container'
import { Col, Row, Menu, Dropdown, Button, Typography} from 'antd'
import InstallationListing from './InstallationListing';
import ModalUtil from 'utils/modalUtil';
import GitInstallationPupop, { GitEnterpriseInstallationPupop } from "./GitInstallationPupop";
import { AdditionalSettingIcon, GitHubIcon } from "components/Icons";
import { BASE_GUTTER } from 'constants/Layout';
import { DownOutlined } from '@ant-design/icons';
import AuthorisedContainer from 'components/AuthorisedContainer';
import { PermissionSetMap } from 'constants/RBACConstants';
import { useActiveUserContext } from "contexts/ActiveUserContext";
import GithubPATConfigForm from './GithubPATConfigForm';

export const GithubDashboardNew = ({ data, onUpdateConfigComponent, name }) => {
  const { sessionData } = useActiveUserContext()

  const showConfigPopup = () => {
    ModalUtil.show({
        content: <GitInstallationPupop toolName={name}/>,
        afterClose: onUpdateConfigComponent
    });
  }

  const handleMenuClick = ({key}) => {
    if(key === "cloud") {
      showConfigPopup();
    } else if(key === "enterprise") {
      ModalUtil.show({
        content: <GitEnterpriseInstallationPupop toolName={name}  />,
        afterClose: onUpdateConfigComponent
      });
    } else if(key === "PAT") {
      ModalUtil.show({
        content: <GithubPATConfigForm toolName={name} />,
        afterClose: onUpdateConfigComponent
      });
    }
  }

  const menu =  (
    <Menu onClick={handleMenuClick}>
     {!sessionData.isCustomerDeployedInstance && <Menu.Item key="cloud" icon={<GitHubIcon />}>
        &emsp; ArmorCode GitHub App
      </Menu.Item>
      } 
      <Menu.Item key="enterprise" icon={<GitHubIcon />}>
        &emsp; Custom GitHub App
      </Menu.Item>
      <Menu.Item key="PAT" icon={<GitHubIcon />}>
        &emsp; Personal Access Token
      </Menu.Item>
    </Menu>
  );

  return (
      <>
      <Row gutter={BASE_GUTTER}>
        <Col span={24} className="d-flex justify-content-between align-items-center">
          <AuthorisedContainer permission={PermissionSetMap.WRITE_TOOLS}>
          <Dropdown overlay={menu} trigger={["click"]}>
            <Button>
              <GitHubIcon />&emsp;Connect to GitHub<DownOutlined />
            </Button>
          </Dropdown>
          </AuthorisedContainer>
          <div>
            <Typography.Link href={"/api/jwt/zendesk/sso?return_to=https://support.armorcode.com/hc/en-us/articles/44059707211539-GitHub-Integration"} target="_blank" className='m-r-sm'>How to setup GitHub ?</Typography.Link>
          </div>
        </Col>
      </Row>
        <Container className="m-b-sm" bodyStyle={{paddingTop: "15px"}}>
          <InstallationListing onUpdateConfigComponent={onUpdateConfigComponent} listingData={data} name={name} />
        </Container>

      </>
  )
}


export const GithubAdditionalSettingsButton = ({
  onAdditionalSettingsClick,
}) => {
  return (
    <Button size="small" onClick={onAdditionalSettingsClick}>
      <AdditionalSettingIcon />
      <span>Additional Settings</span>
    </Button>
  );
};

